import { ReactNode, useEffect, FC } from "react"
import { useNavigate } from "react-router-dom"
import useAuth from "../hooks/useAuth"

interface SuperAdminAuthGuardProps {
    children: ReactNode;
}

const SuperAdminAuthGuard: FC<SuperAdminAuthGuardProps> = ({ children }) => {

    const navigate = useNavigate()
    const { isSuperAdminLoggedIn } = useAuth()

    useEffect(() => {
        // Only redirect if not logged in as super admin and not already on /superadmin/login
        if (!isSuperAdminLoggedIn) {
            navigate('/superadmin/login', { replace: true })
        }
    }, [isSuperAdminLoggedIn, navigate])

    return <>{isSuperAdminLoggedIn ? children : null}</>
}

export default SuperAdminAuthGuard; 